import Banner from './Banner';
import unia from './img/unia.png';
import wyjazd1 from './img/wyjazd1.jpeg';
import wyjazd2 from './img/wyjazd2.jpeg';
import wyjazd3 from './img/wyjazd3.jpeg';

let MainPage = () => {
    return(
        <div id = "textContainer">
            <h1 id="mainPageH1">Zawodowcy z Informatyka na europejskim rynku pracy</h1>
            <hr />
            <Banner />
            <hr /> <br />
            <p>Projekt "Zawodowcy z Informatyka na europejskim rynku pracy" jest skierowany do uczniów klas trzecich i czwartych o profilu technik informatyk, technik programista oraz technik teleinformatyk w Zespole Szkół Informatycznych w Kielcach. W poprzednich latach projekt cieszył się dużą popularnością wśród uczniów i jesteśmy przekonani, że w kolejnych edycjach będzie podobnie.</p>
            
            <div id = "imageContainer">
                <img className = "oldPhoto" src = {wyjazd1} /> <img className = "oldPhoto" src = {wyjazd2} /> <img className = "oldPhoto" src = {wyjazd3} />
            </div>
            
        </div>
    )
}

export default MainPage;